import React, { useState } from "react";
import { Card } from "@/components/UI";
import { Archive, CaretDown, Scales, CurrencyCircleDollar } from "@phosphor-icons/react";
import { WeeklyCard } from "./WeeklyCard";
import { monthLabel } from "./helpers";


export function MonthlyArchive({ month, cards, fmt, onChanged, onRemoved, onMutate }) {
  const [open, setOpen] = useState(false);
  const totalKg = cards.reduce((s, c) => s + (c.total_kg || 0), 0);
  const totalTon = totalKg / 1000;
  const totalCost = cards.reduce((s, c) => s + (c.total_cost || 0), 0);

  return (
    <Card testId={`calf-archive-${month}`} className="!p-0 overflow-hidden">
      <button type="button" data-testid={`calf-archive-toggle-${month}`} onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        className="w-full flex flex-wrap items-center justify-between gap-2 px-4 py-3.5 bg-[#F2EFE8] hover:bg-[#ECE8DF] border-b border-[#E5E2DC] text-left transition-colors">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="p-1.5 bg-white rounded-md border border-[#E5E2DC]">
            <Archive size={18} weight="duotone" className="text-[#8B6914]" />
          </div>
          <div>
            <div className="font-semibold text-[#1A1D1A]">{monthLabel(month)}</div>
            <div className="text-xs text-[#8a938c]">{cards.length} haftalık kart · arşivlendi</div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right">
            <div className="text-sm font-bold tabnum text-[#2D4A36] flex items-center gap-1 justify-end">
              <Scales size={13} weight="duotone" /> {fmt(Math.round(totalTon * 1000) / 1000)} ton
            </div>
            <div className="text-xs tabnum text-[#C45B45] flex items-center gap-1 justify-end">
              <CurrencyCircleDollar size={12} weight="duotone" /> {fmt(Math.round(totalCost))} ₺
            </div>
          </div>
          <CaretDown size={16} weight="bold" className={`text-[#8a938c] transition-transform ${open ? "rotate-180" : ""}`} />
        </div>
      </button>
      {open && (
        <div className="p-3 space-y-3 bg-[#FBFAF7]" data-testid={`calf-archive-body-${month}`}>
          {cards.map(c => (
            <WeeklyCard key={c.id} card={c} fmt={fmt}
              onChanged={onChanged} onRemoved={onRemoved} onMutate={onMutate} />
          ))}
        </div>
      )}
    </Card>
  );
}
